<template>
  <div>
    <v-card flat class="pa-1">
      <v-breadcrumbs class="systock-breadcrump" dark>
        <v-breadcrumbs-item>Configurações do Sistema</v-breadcrumbs-item>
      </v-breadcrumbs>

      <v-tabs centered>
        <v-tab>
          <v-icon left>mdi-wallet-travel</v-icon>
          Empresa
        </v-tab>
        <v-tab>
          <v-icon left>mdi-account-plus</v-icon>
          Compradores
        </v-tab>
        <v-tab>
          <v-icon left>mdi-truck</v-icon>
          Fornecedores
        </v-tab>
        <v-tab>
          <v-icon left>mdi-account-group</v-icon>
          Grupos
        </v-tab>
        <v-tab>
          <v-icon left>mdi-home-group</v-icon>
          Grupo Filial
        </v-tab>
        <v-tab>
          <v-icon left>mdi-ray-start-end</v-icon>
          Sistemas de Integração
        </v-tab>
        <v-tab>
          <v-icon left>mdi-apps</v-icon>
          Sistemas e Aplicativos
        </v-tab>
        <v-tab>
          <v-icon left>mdi-apps</v-icon>
          Informações de Filial
        </v-tab>
        <v-tab>
          <v-icon left>mdi-apps</v-icon>
          Release Notes
        </v-tab>
        <v-tab>
          <v-icon left>mdi-cogs</v-icon>
          Parametrizações filiais compra
        </v-tab>

        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <cfg-empresa></cfg-empresa>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <cfg-comprador
                @novoComprador="comprador = $event"
              ></cfg-comprador>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <cfg-fornecedor :atualizarForn="comprador"></cfg-fornecedor>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <cfg-grupos @novoGrupo="grupo = $event"></cfg-grupos>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <cfg-grupo-filial
                :atualizarGrupoFilial="grupo"
              ></cfg-grupo-filial>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <cfg-sistemas-integracao></cfg-sistemas-integracao>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <cfg-sistemas-app></cfg-sistemas-app>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <cfg-filial-relatorio></cfg-filial-relatorio>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <cadastro-releases />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <ParametrizacaoFiliaisCompra />
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>
import CfgFornecedor from "./CfgFornecedor";
import CfgComprador from "./CfgComprador";
import CfgEmpresa from "./CfgEmpresa";
import CfgGrupos from "./CfgGrupos";
import CfgGrupoFilial from "./CfgGrupoFilial";
import CfgSistemasIntegracao from "./CfgSistemasIntegração";
import CfgSistemasApp from "./CfgSistemasAplicativos";
import cfgFilialRelatorio from "./FilialRelatorio"
import CadastroReleases from "./releasesNotes/CadastroReleases";
import ParametrizacaoFiliaisCompra from "./ParametrizacaoFiliaisCompra";

export default {
  components: {
    CfgFornecedor,
    CfgComprador,
    CfgEmpresa,
    CfgGrupos,
    CfgGrupoFilial,
    CfgSistemasIntegracao,
    CfgSistemasApp,
    cfgFilialRelatorio,
    CadastroReleases,
    ParametrizacaoFiliaisCompra,
  },
  name: "Cfg",

  data() {
    return {
      comprador: 0,
      grupo: 0,
    };
  },

  created() {
    this.Helpers.verificarToken();
  },
};
</script>
<style>
.altura-tabela .v-data-table__wrapper {
  height: calc(100vh - 300px) !important;
}
</style>
